import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import {
  Typography,
  Box,
  Button,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TextField,
  Grid,
  Card,
  IconButton,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useMessage } from "../../context/message-context";
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import AI_CHAT from "../AI_CHAT";
import { render } from "@testing-library/react";
function DigitaleEntgeltabrechnung(props) {
  const { t } = useTranslation();
  const { client, accessToken, program, ansprung, payroll, monate } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMonat, setSelectedMonat] = useState(monate[0]);
  const [bruttoDaten, setBruttoDaten] = useState({});
  const [steuerDaten, setSteuerDaten] = useState({});

  const [expandBruttoDaten, setExpandBruttoDaten] = useState(false);
  const [expandedBlocks, setExpandedBlocks] = useState([]);
const [selectedSachverhalt,setSelectedSachverhalt]=useState("")

const [selectedModus,setSelectedModus]=useState("")
  // const [expandSteuerDaten, setExpandBruttoDaten] = useState(false);
const [aiModal,setAiModal]=useState(false)

  const [chatWindow, setChatWindow] = useState(false);
  const [selectedLohnart, setSelectedLohnart] = useState("");
    const [chatWindow2, setChatWindow2] = useState(false);

  const { hideMessage, showErrorMessage } = useMessage();

  // useEffect(() => {
  //   setIsLoading(true);
  //   const payload = {
  //     mandant: client,
  //     program: "LWEB01",
  //     statement: "LADE_DETAILS",
  //     payroll: payroll,
  //   };
  //   const headers = {
  //     Authorization: "Bearer " + accessToken,
  //   };
  //   apiRequest("POST", "daten", payload, headers, initCB, errorCb);
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB01",
      statement: "LADE_DETAILS",
      payroll: selectedMonat.key,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, initCB, errorCb);
    // eslint-disable-next-line
  }, [selectedMonat]);
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut."));
  };
  const initCB = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
      setBruttoDaten(response.data.bruttoDaten);
      setSteuerDaten(response.data.steuerDaten);
    }
    // setIsLoading(false);
    // showErrorMessage(t("Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut."));
  };

  if (isLoading) {
    return <LoadingComponent />;
  }
  const vorherigerMonat = () => {
    setSelectedMonat(monate[monate.findIndex((e) => e.key === selectedMonat.key) + 1]);
  };
  const naechsterMonat = () => {
    setSelectedMonat(monate[monate.findIndex((e) => e.key === selectedMonat.key) - 1]);
  };
  function formatNumberGerman(number) {
    if (number === undefined) return "0,00";
    return number.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  const loadProtokoll = (modus) => {    
    // setSelectedLohnart(sachverhalt.key);
    // setSelectedSachverhalt(sachverhalt.sachverhalt)
    // setSelectedModus(modus)
    setSelectedLohnart(modus.key)
    setChatWindow(true);
  };
  const renderBlock = (daten, titel) => {
    return (
      <Box p={1}>
        <Paper>
          <Box p={2}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography align="left">{titel}</Typography>
              </Grid>
              <Grid item xs={11}>
             
                <Typography variant="h3" align="right" fontWeight={500}>
                  {/* {formatNumberGerman(parseFloat(daten.summe)) + " €"} */}
                </Typography>
                <p style={{ color: "#6b7280", textAlign: "right", margin: 0, fontSize: "14px" }}>{daten?.positionen?.length + t(" Bestandteil(e)")}</p>
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => {
                    if (expandedBlocks.includes(titel)) {
                      setExpandedBlocks(expandedBlocks.filter((item) => item !== titel));
                    } else {
                      setExpandedBlocks([...expandedBlocks, titel]);
                    }
                  }}
                >
                  {expandedBlocks.includes(titel) ? <KeyboardArrowDown size="small" /> : <KeyboardArrowUp />}
                </IconButton>
              </Grid>
            </Grid>
            {expandedBlocks.includes(titel)
              ? daten?.positionen?.map((position) => (
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Typography align="left">{position.bez}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography align="right">{formatNumberGerman(parseFloat(position.betrag)) + " €"}</Typography>
                    </Grid>
                    <Grid item xs={4} onClick={() => loadProtokoll(position)}>
                      <Button>laden</Button>
                    </Grid>
                  </Grid>
                ))
              : ""}
          </Box>
        </Paper>
      </Box>
    );
  };
  return (
    <>
      <Button onClick={() => vorherigerMonat()} disabled={monate.findIndex((e) => e.key === selectedMonat.key) + 1 === monate.length}>
        Vorheriger Monat
      </Button>
      {selectedMonat?.text}
      <Button onClick={() => naechsterMonat()} disabled={monate.findIndex((e) => e.key === selectedMonat.key) === 0}>
        Nächtster Monat
      </Button>
      {renderBlock(bruttoDaten, "Bruttolohn")}
      {renderBlock(steuerDaten, "Steuerabgaben")}

      {/* <Box p={1}>
        <Paper>
          <Box p={2}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography align="left">Bruttolohn</Typography>
              </Grid>
              <Grid item xs={11}>
                <Typography variant="h3" align="right" fontWeight={500}>
                  {formatNumberGerman(parseFloat(bruttoDaten.summe)) + " €"}
                </Typography>
                <p style={{ color: "#6b7280", textAlign: "right", margin: 0, fontSize: "14px" }}>{bruttoDaten?.lohnarten?.length + t(" Bestandteile")}</p>
              </Grid>
              <Grid item xs={1}>
                <IconButton aria-label="expand row" size="small" onClick={() => setExpandBruttoDaten(!expandBruttoDaten)}>
                  {expandBruttoDaten ? <KeyboardArrowDown size="small" /> : <KeyboardArrowUp />}
                </IconButton>
              </Grid>
            </Grid>
             {expandBruttoDaten? bruttoDaten.lohnarten?.map((loa) => (
            <Grid container spacing={1}>
              <Grid item xs={8}><Typography align="left" >{loa.bez}</Typography></Grid>
              <Grid item xs={4}><Typography align="right">{formatNumberGerman(parseFloat(loa.betrag))+" €"}</Typography></Grid>
                            <Grid item xs={4} onClick={()=>loadProtokoll(loa.key)}><Button>laden</Button></Grid>

            </Grid>
          )):""}
          </Box>
         
        </Paper>
      </Box> */}
      {/* <Box p={1}>
        <Paper>
          <Box p={2}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography align="left">Steuerdaten</Typography>
              </Grid>
              <Grid item xs={11}>
                <Typography variant="h3" align="right" fontWeight={500}>
                  {formatNumberGerman(parseFloat(steuerDaten.summe)) + " €"}
                </Typography>
                <p style={{ color: "#6b7280", textAlign: "right", margin: 0, fontSize: "14px" }}>{steuerDaten?.positionen?.length + t(" Bestandteil(e)")}</p>
              </Grid>
              <Grid item xs={1}>
                <IconButton aria-label="expand row" size="small" onClick={() => setExpandBruttoDaten(!expandBruttoDaten)}>
                  {expandBruttoDaten ? <KeyboardArrowDown size="small" /> : <KeyboardArrowUp />}
                </IconButton>
              </Grid>
            </Grid>
            {expandBruttoDaten
              ? bruttoDaten.lohnarten?.map((loa) => (
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Typography align="left">{loa.bez}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography align="right">{formatNumberGerman(parseFloat(loa.betrag)) + " €"}</Typography>
                    </Grid>
                    <Grid item xs={4} onClick={() => loadProtokoll(loa.key)}>
                      <Button>laden</Button>
                    </Grid>
                  </Grid>
                ))
              : ""}
          </Box>
        </Paper>
      </Box> */}
   <Button onClick={()=> setAiModal(true)}>AI Frage</Button>
      <ResponsiveDialog
        title={"Entgeltabrechnung"}
        open={aiModal}
        setOpen={() => setAiModal(false)}
        actionButton={
          <Button color="primary" onClick={() => setChatWindow(false)}>
            {t("Abbrechen")}
          </Button>
        }
      >
        <AI_CHAT
          client={client}
          accessToken={accessToken}
          program="LWEB01"
          ansprung="AI_ASSISTANT"
          übergabe={{  MODUS: "KOMPLETTE_ENTGELT_HILFE" ,monat:selectedMonat.key}}
        />
      </ResponsiveDialog>
            <ResponsiveDialog
        title={"Entgeltabrechnung"}
        open={chatWindow}
        setOpen={() => setChatWindow(false)}
        actionButton={
          <Button color="primary" onClick={() => setChatWindow(false)}>
            {t("Abbrechen")}
          </Button>
        }
      >
        <AI_CHAT
          client={client}
          accessToken={accessToken}
          program="LWEB01"
          ansprung="AI_ASSISTANT"
          übergabe={{ key: selectedLohnart, MODUS: "EIGENE_ENTGELT_LOHNARTEN_HILFE" ,sachverhalt:selectedSachverhalt}}
        />
      </ResponsiveDialog>

       <ResponsiveDialog
        title={"Entgeltabrechnung2"}
        open={chatWindow2}
        setOpen={() => setChatWindow2(false)}
        actionButton={
          <Button color="primary" onClick={() => setChatWindow(false)}>
            {t("Abbrechen")}
          </Button>
        }
      >
        <AI_CHAT
          client={client}
          accessToken={accessToken}
          program="LWEB01"
          ansprung="AI_ASSISTANT"
          übergabe={{ key: selectedMonat.key, MODUS: "EIGENE_ENTGELT_LOHNARTEN" ,sachverhalt:"LOHNARTEN"}}
        />
      </ResponsiveDialog>
    </>
  );
}
export default DigitaleEntgeltabrechnung;
